import { Entity } from '@backstage/catalog-model';
import { saveJson } from '@agilelab/plugin-wb-platform';
import { extractEnvironmentParameters } from '@agilelab/plugin-wb-platform-common';
import { extractTemplateValues } from './extractTemplateValues';
import { stringifyEntityRef } from '@backstage/catalog-model';

export const DOWNLOAD_DEFAULT_VALUES = {
  tableFormat: 'Download the template parameters',
  cardFormat:
    'Download an example request body to instantiate this template via the builder APIs programmatically',
};

export const COPY_TEMPLATE_REF = {
  tableFormat: 'Copy the template reference',
  cardFormat:
    'Copy the template reference to interact with the builder APIs programmatically',
};

export const downloadTemplateDefaultValues = (entity: Entity): void => {
  const {
    values,
    requiredFields: _,
    hiddenFields,
  } = extractTemplateValues(entity);

  const downloadValues: Record<string, unknown> = Object.fromEntries(
    Object.keys(values)
      .filter((key: string) => !hiddenFields.has(key))
      .map((key: string) => [key, values[key]]),
  );
  const { parameters, environmentParameters } = extractEnvironmentParameters({
    parameters: downloadValues,
  });
  const extractedValues = {
    values: parameters,
    environmentParameters,
  };
  saveJson(extractedValues, 'values.json');
};

export const copyTemplateRef = (entity: Entity): void => {
  const templateRef = stringifyEntityRef(entity);
  navigator.clipboard.writeText(templateRef);
};
